import React, { ReactElement, ReactNode, createContext, useContext, useState } from 'react';
import getClientEnvironment from './environmentManager';
import { Environment, RuntimeContext } from './environmentModels';
import getAccessType from './getAccessType';

const RuntimeContextContext = createContext<RuntimeContext | undefined>(undefined);

type RuntimeContextProviderProps = {
  children: ReactNode;
  getEnvironment?: () => Environment;
};

function RuntimeContextProvider({
  children,
  getEnvironment = getClientEnvironment,
}: RuntimeContextProviderProps): ReactElement {
  const [accessType] = useState(getAccessType());
  const [environment] = useState(getEnvironment());

  return (
    <RuntimeContextContext.Provider value={{ environment, accessType }}>{children}</RuntimeContextContext.Provider>
  );
}

function useRuntimeContext(): RuntimeContext {
  return useContext(RuntimeContextContext)!;
}

export { RuntimeContextProvider, useRuntimeContext };
